export default __webpack_public_path__ + "static/media/background.07c5a770.jpg";